export const getSessionId = () => {
  let id = localStorage.getItem('fff_session');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('fff_session', id);
  }
  return id;
};
